module.exports = __webpack_public_path__ + "img/方块初级大师@2x.9d62e800.png";